import React from 'react';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';

const Layout: React.FC<{ children: React.ReactNode; cartItemsCount?: number }> = ({
  children,
  cartItemsCount,
}) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      bgcolor: 'background.default',
    }}
  >
    <Header cartItemsCount={cartItemsCount} />
    <Box component="main" sx={{ flexGrow: 1 }}>
      {children}
    </Box>
    <Footer />
  </Box>
);

export default Layout;
